import { ToyBrickMarkerIcon } from './ToyBrickMarkerIcon';

/**
 * author: Michael Richins
 * id 602DF6D1-21C6-4540-960D-79D7C37AECF9
 * name toy-brick-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick-marker.svg
 * tags
 * - Navigation 
 */
export const LegoLocationIcon = ToyBrickMarkerIcon;
export default LegoLocationIcon